module.exports = "<h1>Change stuff about the taxonomy</h1>\n"